"use client";

import Link from "next/link";
import { useActionState } from "react";
import { useFormStatus } from "react-dom";
import { requestPasswordResetAction } from "@/app/actions/password-reset.actions";
import { AuthShell } from "@/components/auth/AuthShell";
import { Alert } from "@/components/ui/Alert";
import { Button } from "@/components/ui/Button";
import { Input } from "@/components/ui/Input";
import { Label } from "@/components/ui/Label";
import { Spinner } from "@/components/ui/Spinner";
import type { LoginState } from "@/types/auth";

function SubmitButton() {
    const { pending } = useFormStatus();
    return (
        <Button className="h-11 w-full rounded-lg text-base" type="submit" disabled={pending}>
            {pending ? <><Spinner />Enviando…</> : "Enviar enlace"}
        </Button>
    );
}

export function ForgotPasswordClient() {
    const [state, formAction] = useActionState<LoginState, FormData>(requestPasswordResetAction, { ok: false });

    return (
        <AuthShell
            title="Recuperar contraseña"
            description="Escribe el correo de tu cuenta y te enviaremos un enlace para elegir una nueva contraseña."
            footer={
                <Link href="/login" className="font-medium text-primary underline-offset-4 hover:underline">
                    Volver a iniciar sesión
                </Link>
            }
        >
            {state.ok ? (
                <Alert variant="success" role="status" aria-live="polite" className="grid-cols-1">
                    {state.message} Revisa también la carpeta de spam.
                </Alert>
            ) : (
                <form className="space-y-5" action={formAction}>
                    {state.message && (
                        <Alert variant="destructive" role="status" aria-live="polite" className="grid-cols-1">
                            {state.message}
                        </Alert>
                    )}
                    <div className="space-y-2">
                        <Label htmlFor="email">Correo electrónico</Label>
                        <Input
                            id="email"
                            type="email"
                            name="email"
                            autoComplete="email"
                            placeholder="nombre@empresa.com"
                            required
                            className="h-11 rounded-lg bg-background/50"
                        />
                    </div>
                    <SubmitButton />
                </form>
            )}
        </AuthShell>
    );
}
